<template>
  <v-text-field  data-testid="number__textfield" ref="element" :step="step" :style="`max-width: ${width} !important`" outlined dense type="number" :label="label" :clearable="clearable" :min="min || ''" :max="max || ''"
    :error-messages="computedErrorMessages" :prepend-inner-icon="prependiconinner" :append-icon="appendiconinner" v-model="displayContent" @click:clear="content = '';tempContent=''" @input="updateValue()" :hide-details="computedHideDetails" :disabled="disabled"
    :placeholder="placeholder" :rules="rules"  :background-color="backgroundColor" class="number-field" v-bind="$attrs"
  >
    <template v-if="$slots.append" class="input-image-slot" v-slot:append>
      <slot name="append"></slot>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    inheritAttrs: false,
    activated() {
      this.setValue();
      this.updateValue();
    },
    created() {
      this.setValue();
      this.updateValue();
    },
    data: () => ({
      content: "",
      tempContent: 0.00000000000001,
      minMaxError: ""
    }),
    props: {
      error: {
        type: [String, Array, Boolean],
      },
      appendiconinner: {
        type: String,
        default: ""
      },
      prependiconinner: {
        type: String,
        default: ""
      },
      label: {
        type: String,
        default: ""
      },
      step: {
        type: String,
        default: "1"
      },
      value: {
        type: [String, Number],
        // type: String,
        default: 0
      },
      min: {
        type: String,
        default: ""
      },
      backgroundColor: {
        type: String,
        default: ""
      },
      max: {
        type: [String, Number],
        default: ""
      },
      width: {
        type: String,
        default: ""
      },
      hidedetails: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      ignoredFieldDefaultValue:{
        type:Number,
        default:0.00000000000001
      },
      placeholder:{
        type:String,
        default:''
      },
      rules:{
        type:Array,
        default: () => [
            
          ]
      },
      showMinMaxError: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      setValue: function(){
        if (this.showMinMaxError) {
          // Don't auto-correct, preserve value and show validation error
          let v = this.value.toString();
          const numValue = Number(v);
          if(v == this.ignoredFieldDefaultValue){
            this.tempContent = "";
          } else {
            this.tempContent = v;
          }
          // Validate and set error; reflect invalid state with null
          if (!isNaN(numValue)) {
            this.content = numValue;
            if (this.min !== '' && !isNaN(Number(this.min)) && numValue < Number(this.min)) {
              this.minMaxError = `Value must be at least ${this.min}`;
            } else if (this.max !== '' && !isNaN(Number(this.max)) && numValue > Number(this.max)) {
              this.minMaxError = `Value must be at most ${this.max}`;
            } else {
              this.minMaxError = '';
            }
          } else {
            this.content = null;
            this.minMaxError = 'Please enter a valid number';
          }
        } else {
          // Legacy behavior: auto-correct values
          let v = this.checkRules(this.value.toString()).toString();
          if(v == this.ignoredFieldDefaultValue){
            this.tempContent = "";
          } else {
            this.tempContent = v;
          }
          this.content = Number(v) ?? v;
        }
      },
      updateValue: function () {
        if(this.tempContent === ''){
          this.tempContent = '0';
        }
        
        // Validate min/max and show error if showMinMaxError is enabled
        if (this.showMinMaxError) {
          const numValue = Number(this.tempContent);
          if (!isNaN(numValue)) {
            if (this.min !== '' && !isNaN(Number(this.min)) && numValue < Number(this.min)) {
              this.minMaxError = `Value must be at least ${this.min}`;
            } else if (this.max !== '' && !isNaN(Number(this.max)) && numValue > Number(this.max)) {
              this.minMaxError = `Value must be at most ${this.max}`;
            } else {
              this.minMaxError = '';
            }
          } else {
            this.content = null;
            this.minMaxError = 'Please enter a valid number';
          }
          // Don't auto-correct, just show error and update content
          if(!isNaN(numValue)) {
            this.content = numValue;
          }
        } else {
          // Legacy behavior: auto-correct values
          this.tempContent = this.checkRules(this.tempContent).toString();
          if(isNaN(Number(this.tempContent))) this.tempContent = this.checkRules(this.content).toString();
          else this.content = Number(this.tempContent) ?? this.tempContent;
        }
        
        this.$emit('input', this.content);
        this.$emit('change', this.content); 
      },
      setFocus: function(){
        this.$nextTick(() => {
          this.$refs.element.$el.querySelector('input').focus();
        });
      },
      checkRules: function(x){
        if(x){
          let v = Number(x)
          if(this.min && !isNaN(Number(this.min))) if(v < Number(this.min)) v = this.min;
          if(this.max && !isNaN(Number(this.max))) if(v > Number(this.max)) v = this.max;
          return v;
        }else return "";
      },
    },
    computed:{
      displayContent: {
        get() {
          return this.tempContent == 0.001 ? '' : this.tempContent;
        },
        set(value) {
          this.tempContent = value;
        }
      },
      computedErrorMessages() {
        // Show minMaxError first if it exists
        if (this.minMaxError) {
          return this.minMaxError;
        }
        if (typeof this.error === 'boolean') {
          return '';
        }
        return this.error;
      },
      computedHideDetails() {
        // Show details/error message when there's a minMaxError, even if hidedetails is true
        if (this.minMaxError) {
          return false;
        }
        return this.hidedetails;
      }
    },
    watch: {
      value: function(){
        this.setValue();
      },
    }
  }
</script>

<style>
.number-field .v-input__append-inner {
  margin-top: 0 !important;
  margin: auto !important;
}
</style>